import { useDebouncedValue } from '@/hooks/useDebouncedValue'
import { courseCatalogApi } from '@/services/api/tenant/courseCatalogEnhanced'
import { useCourseSearchFormContext } from './useCourseSearchFormContext'

export const useSearchCourses = (page?: number, size?: number) => {
  const { values } = useCourseSearchFormContext()
  const { name } = useDebouncedValue(values, 100)

  return courseCatalogApi.endpoints.listCourses.useQuery({ query: name.trim(), page, size })
}
